import { Button, CircularProgress } from "@mui/material";
import { useStyles } from "./DetailsReportFilters.styles";
import { useTranslation } from "react-i18next";
import useDetailsReportFilters, { initialDetailsReportFilters } from "./useDetailsReportFilters";
import FilterSelect from "components/MainSelect/MainSelect.view";
import { MillDashboardContext } from "contexts/MillDashboardsContext/MillDashboardsContext";
import { useContext } from "react";
import { FiltersDefaultButton } from "pages/Corporate/components/FiltersDefaultButton/FiltersDefaultButton.view";

const DetailsReportFilters = () => {
    const classes = useStyles();
    const {
        productionLinesOptions,
        machineCentersOptions,
        functionalLocationsOptions,
        failureTypesOptions,
        failureCodesOptions,
        shiftsOptions,
        operatorsOptions,
        isLoading,
        filters,
        applyFilters,
        resetFilters,
        handleFiltersChange,
        setFiltersDefault,
        removeDefaultFilters,
        isFiltersDefault,
        userFiltersDefault,
        loadingDefaultOperations,
    } = useDetailsReportFilters();
    const { t } = useTranslation();

    const { reportRangeEndDate: endDate, reportRangeStartDate: startDate } = useContext(MillDashboardContext);

    if (isLoading) {
        return (
            <div className={`${classes.mainWrapper} ${classes.mainWrapperLoading}`}>
                <CircularProgress color="info" />
            </div>
        );
    }

    return (
        <div className={classes.mainWrapper}>
            <div className={classes.filtersWrapper}>
                <FilterSelect
                    order={"asc"}
                    multiple
                    label={t("locations.summary_report.filters.production_line")}
                    options={productionLinesOptions}
                    value={filters.productionLine}
                    onChange={(event) =>
                        handleFiltersChange({
                            productionLine: event.target.value,
                            machineCenter: initialDetailsReportFilters.machineCenter,
                            functionalLocation: initialDetailsReportFilters.functionalLocation,
                            failureTypes: initialDetailsReportFilters.failureTypes,
                            failureCodes: initialDetailsReportFilters.failureCodes,
                            shift: initialDetailsReportFilters.shift,
                            operator: initialDetailsReportFilters.operator,
                        })
                    }
                />
                <FilterSelect
                    order={"asc"}
                    multiple
                    label={t("locations.summary_report.filters.machine_center")}
                    options={machineCentersOptions}
                    value={filters.machineCenter}
                    onChange={(event) =>
                        handleFiltersChange({
                            machineCenter: event.target.value,
                            functionalLocation: initialDetailsReportFilters.functionalLocation,
                            failureTypes: initialDetailsReportFilters.failureTypes,
                            failureCodes: initialDetailsReportFilters.failureCodes,
                            shift: initialDetailsReportFilters.shift,
                            operator: initialDetailsReportFilters.operator,
                        })
                    }
                />
                <FilterSelect
                    order={"asc"}
                    label={t("locations.summary_report.filters.functional_location")}
                    options={functionalLocationsOptions}
                    value={filters.functionalLocation}
                    onChange={(event) =>
                        handleFiltersChange({
                            functionalLocation: event.target.value,
                            failureTypes: initialDetailsReportFilters.failureTypes,
                            failureCodes: initialDetailsReportFilters.failureCodes,
                            shift: initialDetailsReportFilters.shift,
                            operator: initialDetailsReportFilters.operator,
                        })
                    }
                />
                <FilterSelect
                    order={"asc"}
                    label={t("locations.summary_report.filters.shift")}
                    options={shiftsOptions}
                    value={filters.shift}
                    onChange={(event) =>
                        handleFiltersChange({
                            shift: event.target.value,
                            operator: initialDetailsReportFilters.operator,
                            failureTypes: initialDetailsReportFilters.failureTypes,
                            failureCodes: initialDetailsReportFilters.failureCodes,
                        })
                    }
                />
                <FilterSelect
                    order={"asc"}
                    label={t("locations.summary_report.filters.operator")}
                    options={operatorsOptions}
                    value={filters.operator}
                    onChange={(event) =>
                        handleFiltersChange({
                            operator: event.target.value,
                            failureTypes: initialDetailsReportFilters.failureTypes,
                            failureCodes: initialDetailsReportFilters.failureCodes,
                        })
                    }
                />

                <FilterSelect
                    order={"asc"}
                    multiple
                    label={t("locations.summary_report.filters.failure_type")}
                    options={failureTypesOptions}
                    value={filters.failureTypes}
                    onChange={(event) =>
                        handleFiltersChange({
                            failureTypes: event.target.value,
                            failureCodes: initialDetailsReportFilters.failureCodes,
                        })
                    }
                />
                <FilterSelect
                    multiple
                    order={"asc"}
                    label={t("locations.summary_report.filters.failure_code")}
                    options={failureCodesOptions}
                    value={filters.failureCodes}
                    onChange={(event) =>
                        handleFiltersChange({
                            failureCodes: event.target.value,
                        })
                    }
                />
            </div>
            <div className={classes.filtersActionsWrapper}>
                <FiltersDefaultButton
                    isSelected={isFiltersDefault}
                    hasDefault={!!userFiltersDefault}
                    handleOperation={isFiltersDefault ? removeDefaultFilters : setFiltersDefault}
                    disabled={loadingDefaultOperations}
                />
                <div
                    className={classes.link}
                    onClick={() => {
                        resetFilters();
                    }}
                >
                    {t("locations.summary_report.filters.clear_filters")}
                </div>
                <Button
                    variant="contained"
                    color="info"
                    disabled={!startDate || !endDate}
                    onClick={() => applyFilters()}
                >
                    {t("locations.summary_report.filters.apply_filters")}
                </Button>
            </div>
        </div>
    );
};

export default DetailsReportFilters;
